import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as commonActions from '../common/redux/actions';
import { PluginDetails } from './index';
import CustomLoader from '../common/CustomLoader';
import DocsLink from '../../common/custom/DocsLink';
import ParentDocCard from '../common/ParentDocCard';
import ParentCardNoCol from '../common/ParentCardNoCol';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { showAlertHtml } from '../../common/utils/alert';
import { PLUGIN, pluginCode } from 'drapcode-constant';

export class DefaultPage extends Component {
  static propTypes = {
    plugin: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = { searchTerm: '', searched: false, extensionsSearchList: [] };
  componentDidMount() {
    const { projectId, version } = this.props.match.params;
    this.props.actions.loadAllExtension({ projectId, version });
    this.props.actions.loadAllInstalledPlugin({ projectId, version });
    this.props.actions.deletePermission({ projectId });
    this.props.actions.loadProjectDetail({ projectId, version });
  }

  handleDelete = (installedPluginId) => {
    const {
      plugin: { installedPlugins },
      match,
      actions,
    } = this.props;
    const selectedPlugin =
      installedPlugins && installedPlugins.find((plugin) => plugin.uuid === installedPluginId);
    const { code } = selectedPlugin || '';
    const { projectId, version } = match.params;
    const preConfirm = () => {
      actions.deleteInstalledPlugin({ projectId, installedPluginId, version });
    };

    let alertMsg = "You won't be able to revert this.";
    switch (code) {
      case pluginCode.MULTI_TENANT_SAAS:
        alertMsg = `You won't be able to revert this.</br></br>
        <p style="text-align: left;">
        1. Tenant Collection's reference field will be removed from all the existing collections.</br></br>
        2. A <em>All Items of Current LoggedIn User Tenant</em> filter will be removed from all the existing collections.</br></br>
        3. The selected Tenant collection will be reverted to default DrapCode collection.
        </p>
        `;
        break;
      case pluginCode.DATA_FORM_SEARCH_HISTORY:
        alertMsg = `You won't be able to revert this.</br></br>
          <p style="text-align: left;">
          1. Search History Collection will be removed.</br></br>
          2. Enable Search History trait option will be removed from Search Form component.</br></br>
          </p>
          `;
        break;
      case pluginCode.FILE_ACTIVITY_TRACKER:
        alertMsg = `You won't be able to revert this.</br></br>
          <p style="text-align: left;">
          1. File Activity Tracker Collection will be removed.</br></br>
          </p>
          `;
        break;
      case pluginCode.USER_ACTIVITY_TRACKER:
        alertMsg = `You won't be able to revert this.</br></br>
          <p style="text-align: left;">
          1. User Login Activity Collection will be removed.</br></br>
          </p>
          `;
        break;
      case pluginCode.DATA_VIEW_ACTIVITY_TRACKER:
        alertMsg = `You won't be able to revert this.</br></br>
          <p style="text-align: left;">
          1. Data View Activity Tracker Collection will be removed.</br></br>
          </p>
          `;
        break;
      case pluginCode.TEXT_ANONYMIZATION_ACTIVITY_TRACKER:
        alertMsg = `You won't be able to revert this action.</br></br>
          <p style="text-align: left;">
          1. Text Anonymization Activity Collection will be permanently removed.</br></br>
          2. Text anonymization events will no longer be visible.</br></br>
          </p>
          `;
        break;
      case pluginCode.TYPESENSE_SEARCH:
        alertMsg = `You won't be able to revert this action.</br></br>
            <p style="text-align: left;">
            1. Typesense Search capabilities will be removed.</br></br>
            2. Typesense Configuration will be permanently removed.</br></br>
            3. Typesense Events will no longer be visible.</br></br>
            4. Typesense Component will no longer be visible.</br></br> 
            </p>
            `;
        break;
      case pluginCode.SOCKET_IO:
        alertMsg = `You won't be able to revert this action.</br></br>
            <p style="text-align: left;">
            1. Socket.IO capabilities will be removed.</br></br>
            2. Socket Actions will no longer be visible.</br></br>
            3. Socket.IO templates will no longer be visible.</br></br> 
            4. Socket.IO Activity Tracker Collection will be removed.</br></br>
            </p>
            `;
        break;
      case pluginCode.SENDGRID:
        alertMsg = `You won't be able to revert this action.</br></br>
            <p style="text-align: left;">
            1. Email sending via SendGrid will be disabled.</br></br>
            2. The Send Dynamic Email action will no longer support the SendGrid service.</br></br>
            3. The SendGrid Activity Tracker collection will be deleted.</br></br>
            </p>
            `;
        break;
      case pluginCode.SIGNZY_ACCOUNT_AGGREGATOR:
        alertMsg = `You won't be able to revert this action.</br></br>
            <p style="text-align: left;">
            1. The Account Aggregator FI Transactions collection will be deleted.</br></br>
            2. The Account Aggregator Account Holders collection will be deleted.</br></br>
            3. Signzy Account Aggregator Events will no longer be visible.</br></br>
            4. Request ID, Consent Handle and Internal ID fields will be removed from user collection.</br></br>
            </p>
            `;
        break;
      case pluginCode.SIGNZY_DIGITAL_DOCUMENT_SIGNING:
        alertMsg = `You won't be able to revert this action.</br></br>
            <p style="text-align: left;">
            1. The Digital Document Signing Signers collection will be deleted.</br></br>
            2. The Digital Document Signing Contracts collection will be deleted.</br></br>
            3. Signzy Digital Document Signing Events will no longer be visible.</br></br>
            4. Contract ID field will be removed from user collection.</br></br>
            </p>
            `;
        break;
      case pluginCode.GOOGLE_CALENDAR:
        alertMsg = `You won't be able to revert this action.</br></br>
                  <p style="text-align: left;">
                  1. The Google Calendar OAUTH Tokens collection will be deleted.</br></br>
                  2. Google Calendar Events will no longer be visible.</br></br>
                  3. Google Calendar Mapping section will be removed from the collection's advanced configuration.</br></br>
                  </p>
                  `;
        break;
      case pluginCode.PARKEN:
        alertMsg = `You won't be able to revert this action.</br></br>
            <p style="text-align: left;">
            1. The Parken SMS Activity Tracker collection will be deleted.</br></br>
            2. Parken option will be removed from Send Dynamic SMS Action.</br></br>
            </p>
            `;
        break;
      case pluginCode.RESEND:
        alertMsg = `You won't be able to revert this action.</br></br>
            <p style="text-align: left;">
            1. Email sending via Resend will be disabled.</br></br>
            2. The Send Dynamic Email action will no longer support the Resend service.</br></br>
            3. The Resend Activity Tracker collection will be deleted.</br></br>
            </p>
            `;
        break;
      case pluginCode.GOOGLE_MEET:
        alertMsg = `You won't be able to revert this action.</br></br>
                    <p style="text-align: left;">
                    1. The Google Meet OAUTH Tokens collection will be deleted.</br></br>
                    2. Google Meet Events will no longer be visible.</br></br>
                    3. Google Meet option will be removed from Conference Provider in the Schedule Google Calendar Event action.</br></br>
                    </p>
                    `;
        break;
      case pluginCode.DOCUSIGN:
        alertMsg = `You won't be able to revert this action.</br></br>
                    <p style="text-align: left;">
                    1. The DocuSign Tokens collection will be deleted.</br></br>
                    2. The DocuSign Contracts collection will be deleted.</br></br>
                    3. The DocuSign Signers collection will be deleted.</br></br>
                    4. The DocuSign Activity Tracker collection will be deleted.</br></br>
                    5. DocuSign Events will no longer be visible.</br></br>
                    </p>
                    `;
        break;
      case pluginCode.ZOOM:
        alertMsg = `You won't be able to revert this action.</br></br>
                    <p style="text-align: left;">
                    1. The Zoom OAUTH Tokens collection will be deleted.</br></br>
                    2. Zoom Events will no longer be visible.</br></br>
                    3. Zoom option will be removed from Conference Provider in the Schedule Google Calendar Event action.</br></br>
                    </p>
                    `;
        break;
      case pluginCode.CIBIL:
        alertMsg = `You won't be able to revert this action.</br></br>
                    <p style="text-align: left;">
                    1. CIBIL Events will no longer be visible.</br></br>
                    </p>
                    `;
        break;
      case pluginCode.BOX:
        alertMsg = `You won't be able to revert this action.</br></br>
                    <p style="text-align: left;">
                    1. The Box OAUTH Tokens collection will be deleted.</br></br>
                    2. Box Events will no longer be visible.</br></br>
                    3. Box Folder List Component will no longer be visible.</br></br>
                    </p>
                    `;
        break;
      case pluginCode.QR_GENERATOR:
        alertMsg = `You won't be able to revert this action.</br></br>
                    <p style="text-align: left;">
                    1. QR Events will no longer be visible.</br></br>
                    </p>
                    `;
        break;
      case pluginCode.EMAIL_OTP_AUTHENTICATOR:
        alertMsg = `You won't be able to revert this action.</br></br>
                    <p style="text-align: left;">
                    1. Email OTP Events will no longer be visible.</br></br>
                    2. Email OTPs Collection will be deleted.
                    </p>
                    `;
        break;
      case pluginCode.SMS_OTP_AUTHENTICATOR:
        alertMsg = `You won't be able to revert this action.</br></br>
                    <p style="text-align: left;">
                    1. SMS OTP Events will no longer be visible.</br></br>
                    2. SMS OTPs Collection will be deleted.
                    </p>
                    `;
        break;
      case pluginCode.EMAIL_OTP_CONSENT_VALIDATOR:
        alertMsg = `You won't be able to revert this action.</br></br>
                    <p style="text-align: left;">
                    1. Email Consent OTP Events will no longer be visible.</br></br>
                    2. Email Consent OTPs Collection will be deleted.
                    </p>
                    `;
        break;
      case pluginCode.SMS_OTP_CONSENT_VALIDATOR:
        alertMsg = `You won't be able to revert this action.</br></br>
                    <p style="text-align: left;">
                    1. SMS Consent OTP Events will no longer be visible.</br></br>
                    2. SMS Consent OTPs Collection will be deleted.
                    </p>
                    `;
        break;
      case pluginCode.M_PESA:
        alertMsg = `You won't be able to revert this action.</br></br>
                    <p style="text-align: left;">
                    1. M-Pesa Events will no longer be visible.</br></br>
                    2. MPesa OAUTH Tokens collection will be deleted.
                    3. MPesa Callback Responses collection will be deleted
                    </p>
                    `;
        break;
      case pluginCode.SPIN_MOBILE:
        alertMsg = `You won't be able to revert this action.</br></br>
                    <p style="text-align: left;">
                    1. Spin Mobile Events will no longer be visible.</br></br>
                    2. Spin Mobile OAUTH Tokens collection will be deleted.
                    </p>
                    `;
        break;
      case pluginCode.IPRS_KENYA:
        alertMsg = `You won't be able to revert this action.</br></br>
                    <p style="text-align: left;">
                    1. IPRS - Kenya Event will no longer be visible under Spin Mobile Category.</br></br>
                    2. IPRS Kenya Data collection will be deleted.
                    </p>
                    `;
        break;
      case pluginCode.METROPOL_CREDIT_REPORTS_BUREAU_KENYA:
        alertMsg = `You won't be able to revert this action.</br></br>
                    <p style="text-align: left;">
                    1. Metropol Credit Report Event will no longer be visible under Spin Mobile Category.</br></br>
                    2. Metropol Credit Reports collection will be deleted.</br></br>
                    3. Metropol Account Information collection will be deleted.</br></br>
                    4. Metropol Associations collection will be deleted.</br></br>
                    </p>
                    `;
        break;
      case pluginCode.KRA_PIN_CHECKER:
        alertMsg = `You won't be able to revert this action.</br></br>
                    <p style="text-align: left;">
                    1. KRA PIN Checker Event will no longer be visible under Spin Mobile Category.</br></br>
                    2. KRA PIN Checks collection will be deleted.
                    </p>
                    `;
        break;
      case pluginCode.E_STATEMENT_ANALYSIS:
        alertMsg = `You won't be able to revert this action.</br></br>
                    <p style="text-align: left;">
                    1. E-Statement Analysis Event will no longer be visible under Spin Mobile Category.</br></br>
                    2. E-Statement Analysis collection will be deleted.</br></br>
                    3. E-Statement Analysis Locations collection will be deleted.</br></br>
                    4. E-Statement Analysis Final Classifications collection will be deleted.</br></br>
                    5. E-Statement Analysis Monthly Tabulated collection will be deleted.</br></br>
                    </p>
                    `;
        break;
      case pluginCode.AFRICAS_TALKING_SMS:
        alertMsg = `You won't be able to revert this action.</br></br>
            <p style="text-align: left;">
            1. The Africa's Talking SMS Activity Tracker collection will be deleted.</br></br>
            2. Africa's Talking option will be removed from Send Dynamic SMS Action.</br></br>
            </p>
            `;
        break;
      case pluginCode.HOSTPINNACLE:
        alertMsg = `You won't be able to revert this action.</br></br>
            <p style="text-align: left;">
            1. The HostPinnacle SMS Activity Tracker collection will be deleted.</br></br>
            2. HostPinnacle option will be removed from Send Dynamic SMS Action.</br></br>
            </p>
            `;
        break;
      case pluginCode.BOLDSIGN:
        alertMsg = `You won't be able to revert this action.</br></br>
            <p style="text-align: left;">
            1. The BoldSign Documents collection will be deleted.</br></br>
            2. The BoldSign Signers collection will be deleted.</br></br>
            3. BoldSign Events will no longer be visible.</br></br>
            </p>
            `;
        break;
      default:
        break;
    }

    showAlertHtml(alertMsg, preConfirm, 'Yes, delete it!');
  };

  getAvailablePlugins = (installedPlugins, extensions) => {
    const installedPluginsCode = installedPlugins.map((plugin) => {
      return plugin.code;
    });
    return extensions.filter((plugin) => {
      return !installedPluginsCode.includes(plugin.code);
    });
  };

  handleSearch = () => {
    const { searchTerm } = this.state;
    const {
      plugin: { extensions, installedPlugins },
    } = this.props;
    const availablePlugins = this.getAvailablePlugins(installedPlugins, extensions);
    const extensionsSearchList = availablePlugins.filter((plugin) => {
      if (!searchTerm) {
        return plugin;
      } else if (plugin.name.toLowerCase().includes(searchTerm.toLowerCase())) {
        return plugin;
      }
    });

    this.setState({ extensionsSearchList, searched: true });
  };

  showPluginsCard = (showInstalledPlugin, projectType, checkPermission) => {
    const { plugin, match } = this.props;
    const { projectId, version } = match.params;
    const { extensions, installedPlugins, permissionFlags } = plugin;

    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }
    const { extensionsSearchList } = this.state;
    const availablePlugins = this.getAvailablePlugins(installedPlugins, extensions);
    const isSearched = extensionsSearchList && extensionsSearchList.length > 0;
    if (showInstalledPlugin && extensions && extensions.length > 0) {
      return installedPlugins.map((plugin) => {
        return (
          <div className="grid__column" key={plugin.name}>
            <PluginDetails
              currentPlugin={plugin}
              key={plugin.name}
              projectId={projectId}
              version={version}
              handleDelete={this.handleDelete}
              showInstalledPlugin={showInstalledPlugin}
              checkPermission={checkPermission}
              extensions={extensions}
              flag={permissionsArray.includes(PLUGIN)}
            />
          </div>
        );
      });
    } else if (isSearched) {
      return extensionsSearchList.map((plugin) => {
        return (
          <div className="grid__column" key={plugin.name}>
            <PluginDetails
              currentPlugin={plugin}
              key={plugin.name}
              projectId={projectId}
              version={version}
              handleDelete={this.handleDelete}
              showInstalledPlugin={showInstalledPlugin}
              checkPermission={checkPermission}
              extensions={extensions}
            />
          </div>
        );
      });
    } else if (this.state.searched && !isSearched) {
      return <h4>No Plugins Found!</h4>;
    } else {
      return availablePlugins.map((plugin) => {
        return (
          <div className="grid__column" key={plugin.name}>
            <PluginDetails
              currentPlugin={plugin}
              key={plugin.name}
              projectId={projectId}
              version={version}
              handleDelete={this.handleDelete}
              showInstalledPlugin={showInstalledPlugin}
              checkPermission={checkPermission}
              extensions={extensions}
            />
          </div>
        );
      });
    }
  };

  updateSearchTerm = (value) => {
    this.setState({ searchTerm: value });
  };

  render() {
    const { projectId, version } = this.props.match.params;
    const { installedPlugins, loadAllExtensionPending, loadAllInstalledPluginPending } =
      this.props.plugin;
    const { common } = this.props;
    const { projectDetail } = common;
    let projectType = projectDetail && projectDetail.projectType ? projectDetail.projectType : '';

    return (
      <CommonPageComponent>
        <div className="row mx-auto">
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
            <ParentCardNoCol icon="plugins" title="Installed Plugins">
              <div className="center-div">
                <div className="container ml-0">
                  <div className="row mx-auto">
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                      <div className="grid grid--user-profile">
                        {loadAllInstalledPluginPending ? (
                          <div className="text-center">
                            <CustomLoader
                              loading={loadAllInstalledPluginPending}
                              size="20px"
                              color="#303453"
                            />
                          </div>
                        ) : installedPlugins && installedPlugins.length > 0 ? (
                          this.showPluginsCard(true, projectType, false)
                        ) : (
                          <h3>No Installed Plugins!</h3>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ParentCardNoCol>
            <ParentCardNoCol
              bgColor="drapcode-violet"
              icon="plugins"
              title="Available Plugins"
              isSearch={true}
              handleSearch={this.handleSearch}
              updateSearchTerm={this.updateSearchTerm}
            >
              <div className="center-div">
                <div className="container ml-0">
                  <div className="row mx-auto">
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                      <div className="grid grid--user-profile">
                        {loadAllExtensionPending ? (
                          <div className="text-center">
                            <CustomLoader
                              loading={loadAllExtensionPending}
                              size="20px"
                              color="#303453"
                            />
                          </div>
                        ) : (
                          <>{this.showPluginsCard(false, projectType, true)}</>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ParentCardNoCol>
          </div>
          <ParentDocCard>
            <h5>
              <b>About Plugins</b>
            </h5>
            <p>
              Contains all the third-party plugins that allow you to easily integrate additional
              functionalities to your no code/low code web applications.
            </p>
            <br />
            <DocsLink link="https://academy.drapcode.com/docs/app-plugin/plugin-introduction/" />
          </ParentDocCard>
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    plugin: state.plugin,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);
